export const NewReferralPage = (destinationLang) => {
  return [
    {
      FormKey: "new-referral-input-patient-name-id",
      Key: "ثبت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "new-referral-navbar-title",
      Key: "ارجاع جديد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "new-referral-label-id",
      Key: "شناسه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-mobile-number",
      Key: "تلفن همراه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "new-referral-label-file-number",
      Key: "شماره پرونده",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "new-referral-label-NFI",
      Key: "کدملی / شناسه / شماره پرونده",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-label-diagnose",
      Key: "تشخیص",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-address",
      Key: "آدرس",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "new-referral-label-no-address",
      Key: "فاقد آدرس",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "new-referral-label-no-file-number",
      Key: "فاقد شماره پرونده",
      DistinitationLanguage: destinationLang,
    },
  ];
};
